import { render, staticRenderFns } from "./ClientGeoLocation.vue?vue&type=template&id=d2ce3f22&scoped=true&"
import script from "./ClientGeoLocation.vue?vue&type=script&lang=js&"
export * from "./ClientGeoLocation.vue?vue&type=script&lang=js&"
import style0 from "./ClientGeoLocation.vue?vue&type=style&index=0&id=d2ce3f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ce3f22",
  null
  
)

export default component.exports